import { motion } from 'framer-motion';
import { Box, Typography } from '@mui/material';

const ChampionshipCard = ({
    logoText = 'AAGC',
    year = '2025',
    subTitle = 'Asia Auto Gymkhana Championship',
    statusLabel = 'UPCOMING',
    heroImage = '/images/car2.png',
    rounds = [],
}) => (
    <Box
        component={motion.div}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        sx={{
            width: 400,
            color: '#fff',
            borderRadius: 5,
            overflow: 'hidden',
            bgcolor: '#1a1a2e',
            border: '1px solid rgba(255,255,255,0.2)',
            boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
        }}
    >
        {/* Hero image with car */}
        <Box
            sx={{
                position: 'relative', height: 250,
                backgroundPosition: 'center', bgcolor: '#2a2a3e',
                backgroundImage: `url(${heroImage})`, backgroundSize: 'cover',
            }}
        >
            <Box
                sx={{
                    position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                    background: 'linear-gradient(to top, rgba(0,0,0,1) 0%, rgba(0,0,0,0.4) 30%, transparent 100%), linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.1) 25%, transparent 100%)',
                }}
            />
            {/* Header with logo */}
            <Box sx={{ px: 2, py: 1.5, position: "absolute", top: 0, left: 0, zIndex: 10 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, }} >
                    <Typography sx={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '1.8rem', fontWeight: 700, fontStyle: 'italic', textShadow: '0 2px 8px rgba(0,0,0,0.9), 0 0 20px rgba(0,0,0,0.6)' }}  >
                        {logoText}
                    </Typography>
                    <Typography sx={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '1.8rem', fontWeight: 700, color: '#4dabf7', textShadow: '0 2px 8px rgba(0,0,0,0.9), 0 0 20px rgba(77,171,247,0.4)' }} >
                        {year}
                    </Typography>
                </Box>
                <Typography sx={{ fontSize: '0.7rem', letterSpacing: '0.08em', color: 'rgba(255,255,255,1)', textTransform: 'uppercase', fontWeight: 600, textShadow: '0 1px 6px rgba(0,0,0,1), 0 0 12px rgba(0,0,0,0.8)' }}>
                    {subTitle}
                </Typography>
            </Box>

            {/* Status label */}
            <Box sx={{ position: 'absolute', bottom: 12, left: 12, display: 'flex', alignItems: 'center', gap: 1, }} >
                <Box sx={{ width: 16, height: 2, bgcolor: '#fff', filter: 'drop-shadow(0 0 4px rgba(255,255,255,0.8))' }} />
                <Typography sx={{ fontSize: '0.7rem', fontWeight: "bold", letterSpacing: '0.15em', textTransform: 'uppercase', color: 'rgba(255,255,255,1)', textShadow: '0 1px 6px rgba(0,0,0,1), 0 0 12px rgba(0,0,0,0.8)' }} >
                    {statusLabel}
                </Typography>
            </Box>
        </Box>

        {/* Rounds table */}
        <Box sx={{
            backgroundImage: 'linear-gradient(180deg, #1b1f35 0%, #0a0c16 100%)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            p: '20px 0px',
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
        }}>
            {rounds.map((round, index) => (
                <Box
                    key={round.id}
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: '32px 1fr 1fr 28px',
                        alignItems: 'center',
                        px: 1.5,
                        py: 1,
                        margin: "5px 20px",
                        borderRadius: '10px',
                        border: '1.5px solid rgba(255,255,255,0.3)',
                        '&:hover': {
                            bgcolor: 'rgba(255,255,255,0.1)',
                        },
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 600,
                            fontSize: '0.75rem',
                            color: 'rgba(255,255,255,1)',
                        }}
                    >
                        {round.id}
                    </Typography>
                    <Typography
                        sx={{
                            fontWeight: 600,
                            fontSize: '0.75rem',
                            color: 'rgba(255,255,255,1)',
                        }}
                    >
                        {round.month} | {round.dates}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: '0.7rem',
                            fontWeight: 600,
                            color: '#fff',
                            textAlign: 'right',
                            pr: 1,
                        }}
                    >
                        {round.location}
                    </Typography>
                    <Typography sx={{ fontSize: '1rem', textAlign: 'center' }}>
                        {round.flag}
                    </Typography>
                </Box>
            ))}
        </Box>
    </Box>
);

export default ChampionshipCard;
